<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <div class="bg-white flex-box col fill" id="print_area">
                <div class="flex-box-bd"></div>
                <div class="flex-box">
                    <div class="flex-box-bd"></div>
                    <div class="bg-f8 pd-10">
                        <vue-qr :text="code_url" :size="350"></vue-qr>
                        <div class="flex-box mg-top15">
                            <div class="mg-right10"><img class="img-60 round" :src="img_lnk"></div>
                            <div class="flex-box-bd tleft">
                                <div class="f-bd f-brown f16">{{user_cname}} {{user_mobile}}</div>
                                <div class="f-gray f14 mg-top5">员工编号：{{user_code}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-box-bd"></div>
                </div>
                <div class="flex-box-bd"></div>
            </div>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" v-print="printObj">{{$t('print')}}</Button>
        </div>
    </div>
</template>

<script>
    import vueQr from 'vue-qr'
    export default {
        components:{
            vueQr
        },
        data:function(){
            return{
                img_lnk:'',
                user_code:'',
                user_cname:'',
                user_mobile:'',
                code_url:'',//支付二维码

                printObj:{
                    id:'#print_area',
                    popTitle: '-',
                    endCallback(){}
                }
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            var info = this.$base.getRequest();
            this.code_url = this.$config.wxmpUrl+'?p=|2|'+info.user_code;
            this.img_lnk = info.img_lnk;
            this.user_code = info.user_code;
            this.user_cname = info.user_cname;
            this.user_mobile = info.user_mobile;
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/org/ewm/user.vue